import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=25573588&"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports